"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var smileyData = [{
  emoji: "\uD83D\uDE1E",
  label: "Terrible",
  score: 1
}, {
  emoji: "\uD83D\uDE14",
  label: "Bad",
  score: 2
}, {
  emoji: "\uD83D\uDE10",
  label: "Okay",
  score: 3
}, {
  emoji: "\uD83D\uDE01",
  label: "Good",
  score: 4
}, {
  emoji: "\uD83D\uDE06",
  label: "Great",
  score: 5
}];
var _default = exports["default"] = smileyData;